import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// Form related
import { Field } from 'formik';
import { CheckboxWithLabel } from 'formik-material-ui';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
//import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import AuthorisedSignatories from "./AuthorisedSignatories";
import ServiceDetails from "./ServiceDetails";

import connectionFormStyle from "../../../assets/jss/material-dashboard-react/views/connectionFormStyle";

const useStyles = makeStyles(connectionFormStyle);

export default function MultipleNSAForm(props) {
    const classes = useStyles();
    const {formField, values, setFieldValue, setServiceData} = props;

    return (
        <div>
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>Multiple Network Services Application</h4>
                            <p className={classes.cardCategoryWhite}>I request the following connections and porting of the specified MSN(s) as part of my Network Services Application for:</p>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12} sm={4}>
                                    <h4 className={classes.sectionHeader}>Customer Account Details</h4>
                                    <Field
                                        component={CustomInput}
                                        labelText={formField.company_name.label}
                                        name={formField.company_name.name}
                                        id={formField.company_name.name}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            readOnly: true
                                        }}
                                    />
                                    <Field
                                        component={CustomInput}
                                        labelText={formField.account_no.label}
                                        name={formField.account_no.name}
                                        id={formField.account_no.name}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                    <Field
                                        component={CustomInput}
                                        labelText={formField.total_no_services.label}
                                        name={formField.total_no_services.name}
                                        id={formField.total_no_services.name}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            type: "number"
                                        }}
                                    />
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.directory_listed.name}
                                        id={formField.directory_listed.name}
                                        type="checkbox"
                                        Label={{ label: formField.directory_listed.label }}
                                    />
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.multiple_services_enabled.name}
                                        id={formField.multiple_services_enabled.name}
                                        type="checkbox"
                                        Label={{ label: formField.multiple_services_enabled.label }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={8}>
                                    <AuthorisedSignatories
                                        formField={formField}
                                        customerName={values.given_name + " " + values.surname}
                                        declarationText="Terms of Application: I have read and signed the Network Services Application and Are You Aware form and confirm this page is part of that application:"
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer>
                                <GridItem xs={12}>
                                    <ServiceDetails formField={formField} values={values} setFieldValue={setFieldValue} setServiceData={setServiceData} />
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                        <CardFooter>
                            &nbsp;
                        </CardFooter>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}
